export const POLICY_AGRARIANISM_BUILDING_DISCOUNT_WAREHOUSE = 4;

export const POLICY_AGRARIANISM_BUILDING_PRICE_FARM = 2;


